import { DeviationsLoader } from "@src/to-be-removed/api/deviations/deviations.loader";
import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";
import { Utilities } from "../../../../../utils/utilities";
import { DeviationCostData } from "../../../Deviation/DeviationCostData";
import { DeviationData } from "../../../Deviation/DeviationData";
import { FirebaseDataUserField } from "../../DataObjectField/CustomFields/FirebaseDataUserField";
import { DataObjectField } from "../../DataObjectField/DataObjectField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataNumberField } from "../../DataObjectField/Generic/FirebaseDataNumberField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { DataObjectHelpers } from "../../DataObjects/DataObjectHelpers";

export class DeviationCostDataHelper extends DataObjectHelper<DeviationCostData> {
  id = () => "deviationCost";
  taskTitle = new FirebaseDataStringField<DeviationCostData>(
    "taskTitle",
    t("main.taskTitle"),
    (deviationCost) => (deviationCost.parent instanceof DeviationData ? deviationCost.parent.title : ""),
    "task"
  );
  costType = new FirebaseDataStringField<DeviationCostData>("costType", t("main.costType"), (deviationCost) => deviationCost.costType, "payments");
  unitPrice = new FirebaseDataNumberField<DeviationCostData>(
    "unitPrice",
    t("main.unitCost"),
    (deviationCost) => deviationCost.unitPrice,
    "real_estate_agent",
    false,
    { metric: "currency" }
  );
  description = new FirebaseDataStringField<DeviationCostData>(
    "description",
    t("main.description"),
    (deviationCost) => deviationCost.description,
    "description"
  );
  vat = new FirebaseDataNumberField<DeviationCostData>("vat", t("main.vat"), (devationCost) => devationCost.vat, "currency_exchange", false, {
    metric: "currency",
  });
  unitCount = new FirebaseDataNumberField<DeviationCostData>(
    "unitCount",
    t("main.unitCount"),
    (deviationCost) => deviationCost.unitCount,
    "apartment"
  );
  //Usikker på task
  //task = new FirebaseDataSubTaskField<DeviationCostData>("task", t('main.task'), (deviationCost) => deviationCost.task);
  startDate = new FirebaseDataDateField<DeviationCostData>("startDate", t("main.startDate"), (deviationCost) => deviationCost.startDate, "today");
  endDate = new FirebaseDataDateField<DeviationCostData>("endDate", t("main.endDate"), (deviationCost) => deviationCost.endDate, "event");
  user = new FirebaseDataUserField<DeviationCostData>("user", t("main.userName"), (deviationCost) => deviationCost.user, "person");

  allFields(): DataObjectField<any, DeviationCostData>[] {
    return [this.taskTitle, this.costType, this.unitPrice, this.description, this.vat, this.unitCount, this.startDate, this.endDate, this.user];
  }
  displayName = () => t("main.deviation") + " " + t("main.cost");

  override getAllDatas(): DeviationCostData[] {
    const costs: DeviationCostData[] = [];
    for (const deviation of DeviationsLoader.getInstance().getAllDeviationDatas()) {
      for (const cost of deviation.costs.documents) {
        if (cost.costType === "cost") costs.push(cost);
      }
    }
    return costs;
  }

  override async loadAll(): Promise<any> {
    const allPromises: Promise<any>[] = [];

    let deviations: DeviationData[] = [];
    if (DataObjectHelpers.deviation.areAllLoaded()) {
      deviations = DataObjectHelpers.deviation.getAllDatas();
    } else {
      deviations = await DataObjectHelpers.deviation.loadAll();
    }

    for (const deviation of deviations) {
      const promise = new Promise<DeviationCostData[]>((resolve) => {
        deviation.costs.load((costs) => {
          resolve(costs);
        });
      });
      allPromises.push(promise);
    }

    return Promise.all(allPromises);
  }

  getAllDataTableDatas(documents: DeviationCostData[]): DataTableData[] {
    return documents.map((cost) => {
      return {
        key: cost.id,
        cells: {
          taskTitle: cost.parent instanceof DeviationData ? `#${cost.parent.deviationNumber} ${cost.parent.title}` : "",
          description: cost.description,
          price: Utilities.formatNumber(cost.unitPrice) + ",-",
          amount: cost.unitCount,
          vat: cost.vat,
          sumExVat: Utilities.formatNumber((cost.unitPrice ?? 0) * (cost.unitCount ?? 0)) + ",-",
          sumIncVat: Utilities.formatNumber((cost.unitPrice ?? 0) * (cost.unitCount ?? 0) * (cost.vat / 100 + 1)) + ",-",
        },
      };
    });
  }
  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      { key: "taskTitle", title: t("main.task") },
      {
        key: "description",
        title: t("main.description"),
      },
      {
        key: "price",
        title: t("main.priceExVat"),
      },
      {
        key: "amount",
        title: t("main.count"),
      },
      { key: "vat", title: t("main.vat") },
      {
        key: "sumExVat",
        title: t("main.sum") + " (" + t("main.exVat") + ")",
      },
      { key: "sumIncVat", title: t("main.sum") + " (" + t("main.incVat") + ")" },
    ];
  }
}

